
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1c3v6_93",
  "input": "awsui_input_2rhyz_1c3v6_97",
  "input-readonly": "awsui_input-readonly_2rhyz_1c3v6_142",
  "input-invalid": "awsui_input-invalid_2rhyz_1c3v6_203",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_1c3v6_214",
  "input-type-search": "awsui_input-type-search_2rhyz_1c3v6_219",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_1c3v6_235",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1c3v6_238",
  "input-container": "awsui_input-container_2rhyz_1c3v6_242",
  "input-icon-left": "awsui_input-icon-left_2rhyz_1c3v6_247",
  "input-icon-right": "awsui_input-icon-right_2rhyz_1c3v6_254",
  "input-button-right": "awsui_input-button-right_2rhyz_1c3v6_260"
};
  